import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseMedia } from 'entities/Attachment/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: { attachment: IResponseMedia; space_used: number }) => void

export const useEventAttachmentUploadSuccessful = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.AttachmentUploadSuccessful, handler), [])
}
